import { render } from "./CookiesModal.vue?vue&type=template&id=05fe2375&scoped=true"
import script from "./CookiesModal.vue?vue&type=script&lang=js"
export * from "./CookiesModal.vue?vue&type=script&lang=js"

import "./CookiesModal.vue?vue&type=style&index=0&id=05fe2375&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fe2375"]])

export default __exports__